export default (set, get, choiceId, data) => set(
  () => ({
    configurator: {
      ...get().configurator,
      choices: {
        ...get().configurator.choices,
        [choiceId]: {
          ...get().configurator.choices[choiceId],
          ...data
        }
      }
    },
  }),
  false,
  { type: 'configurator/updateChoice', choiceId, data }
);
